export const QueryKey = {
  CHANNEL: 'channel',
  ADMIN_SETTINGS: 'admin settings',
  PROFILE: {
    ME: 'me',
    MANAGE_TAGS: 'manage tags',
    ADMIN_SETTINGS: 'admin settings',
    WEBHOOK_RULE: 'webhook rule',
    SYSTEM: 'system',
    ORG_TYPE: 'org-type',
  },
  AUTHENTICATION: 'authentication',
  TRACKING_OTP: 'tracking otp',
  COUNT: 'count',
  PROJECT: { ALL: 'project', DETAIL: 'project detail' },
  ORDER: 'order',
  KIT: 'kit',
  ORDER_HISTORY: 'orderHistory',
  ADMINISTRATOR: {
    ALL: 'administrator',
    ROLE: 'role',
    ROLE_DETAIL: 'role detail',
    SCOPES: {
      ALL: 'scopes',
      DETAIL: 'scopes detail',
    },
  },
  CUSTOMER: 'customer',
  KIT_SERIAL: 'kitSerials',
  SEQUENCING: {
    BATCH_SEQUENCES: 'get-batch-sequences',
    ALL: 'sequencing',
    ALL_TYPES: 'sequencing-all-type',
    ALL_PARTNER: 'sequencing-all-partner',
    SHORT: 'sequencing-short',
    DETAIL: 'sequencing-detail',
    BYKIT: 'sequenceByKit',
  },
  // EXTRACTION: {
  //   ALL: 'extraction',
  //   DETAIL: 'extraction-detail',
  // },
  EMAIL: { ALL: 'email', BME_TEMPLATE: 'BMETemplates' },
  // KIT_DETAIL: {
  //   KIT_SAMPLES: 'kit-samples',
  // },
  LOGS: {
    PORTAL_ACCESS: 'protal-access',
    ACCESS_PII: 'access-pii',
  },
  REPORT: 'reports',
  PRODUCT: {
    ALL: 'all product',
  },
  ANALYSIS: {
    // ALL: 'all-analysis',
    DETAIL: 'analysis-detail',
    SAMPLES: 'analysis-samples',
  },
  TENANT: {
    BY_SUBDOMAIN: 'tenant-by-subdomain',
    ORG: 'tenant org',
  },
  ORGANIZATION: {
    ALL: 'all organization',
  },
  SAMPLE_BY_KITS: 'sample_by_kits',
  BATCH_PREFIX: 'BATCH_PREFIX',
  ALERT: 'alert',
  ALERT_TYPE: 'alert-type',
  ALERT_ROLE: {
    AMILI_ROLES: 'alert-roles',
  },
  SUB_DOMAIN: 'sub-domain',
  UPLOAD_TERMS: 'upload-terms',
  TRIGGER_PDF_GENERATION_KIT: 'trigger-pdf-generation-kit',
  FMT_BOTTLE: 'fmt-bottle',
  FMT_BOTTLE_LOG: 'fmt-bottle-log',
};

export const OrderQueryKey = {
  all: [{ scope: 'order' }] as const,
  list: () => [{ ...OrderQueryKey.all[0], entity: 'list' }] as const,
  detail: (ids: string[]) => [{ ...OrderQueryKey.list()[0], ids }] as const,
};

export const KitQueryKey = {
  all: [{ scope: QueryKey.KIT }] as const,
  list: () => [{ ...KitQueryKey.all[0], entity: 'list' }] as const,
};

//depend on base url of service
export enum QueryKeysEnum {
  PROFILE = 'profile',
  ORDER = 'orders',
  PROJECT_TENANTS = 'project-tenants',
  PROJECT = 'project',
  CHANNEL = 'channel',
  REPORT = '16s-report',
  ANALYSIS_REPORT = 'analysis-report',
  SHOTGUN_REPORT = 'shotgun-report',
  ORGANIZATION = 'tenants',
  KIT = 'kit',
  KIT_ATTRIBUTE = 'kit-attribute',
  PRODUCT = 'product',
  DAY_DELAY = 'day-delay',
  USER = 'users',
  ADMIN_SETTING = 'admin-setting',
  SAMPLE = 'samples',
  SAMPLE_DNA_EXTRACTION = 'sample-dna-extraction',
  BATCH = 'sequencing-batch',
  EXTRACTION = 'extraction-batches',
  EXTRACTION_SEQUENCE = 'extraction-sequences',
  EXTRACTION_EXPORT = 'export-extraction-batches',
  SEQUENCING_TYPE = 'sequencing-types',
  SEQUENCING_PARTNER = 'sequencing-partners',
  SEQUENCE = 'sequences',
  ORDER_ITEM = 'order-item',
  PRODUCT_HISTORY = 'product-history',
  PRODUCT_GROUP = 'product-group',
  ANALYSIS = 'analysis-batch',
  ANALYSIS_SAMPLE = 'analysis-sample',
  ANALYSIS_SAMPLE_KIT = 'analysis-sample-kits',
  ANALYSIS_STREAM = 'analysis-stream',
  ANALYSIS_COMMERCIAL = 'analysis-commercial',
  TRIGGER_PDF_GENERATION_KIT = 'trigger-pdf-generation-kit',
  ROLE = 'roles',
  FMT_RECIPIENT = 'fmt-recipient',
  FMT_DONOR = 'fmt-donor',
  FMT_PRODUCT = 'fmt-product',
  FMT_CYCLE = 'fmt-cycle',
  FMT_SCREENING_TEST = 'fmt-screening-test',
  FMT_BOTTLE_LOG = 'fmt-bottle-log',
  FMT_BOTTLE = 'fmt-bottle',
  LAKEFS = 'lakefs',
  PDF_ASSETS = 'pdf-assets',
  CUSTOMER = 'customer',
  PROMO_CODE = 'promo-code',
  ORDER_STATUS = 'order-status',
  VALIDATE_ALLOW_DNA_EXTRACTION = 'validate-allow-dna-extraction',
  COMMON = 'common',
  INVOICE = 'invoice',
  PIPELINE_HISTORY = 'pipeline-histories',
  QC_ALERT = 'qc-alerts',
  QC_ALERT_OWNER = 'qc-alert-owners',
  QC_ALERT_LOG = 'qc-alert-logs',
  QC_ALERT_CATEGORY = 'qc-alert-categories',
  ALERT = 'alerts',
  ALERT_CONFIG = 'alert-configs',
  INCIDENT_ALERT_LOGGER = 'incident-alert-loggers',
}
